'use client';

import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { Modal } from '@/components/Modal';
import { networkItems } from './helpers';
import { NetworkItem } from './NetworkItem';

import { ScNetworksModal, ScNetworksModalContainer } from './styled';

export type NetworksModalProps = {
  onClose: () => void;
};

export const NetworksModal: FC<NetworksModalProps> = ({ onClose }) => {
  const { t } = useTranslation('common');

  return (
    <Modal>
      <ScNetworksModalContainer>
        <ScNetworksModal>
          <ButtonClose onClick={onClose} right={12} top={12} />
          <div className="text">
            <div className="title">{t('networksModal.title')}</div>
            <div className="descr">{t('networksModal.descr')}</div>
          </div>
          <div className="network-items">
            {networkItems.map((item, idx) => (
              <NetworkItem {...item} key={idx} />
            ))}
          </div>
          <ImageComponent
            alt="characters"
            className="characters"
            height={156}
            src="/networks/characters.webp"
            width={295}
          />
        </ScNetworksModal>
      </ScNetworksModalContainer>
    </Modal>
  );
};
